export function sliders() {
  $('.slideshow').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: false,
    fade: true
  });

  $('.schedule__list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    appendArrows: '.schedule__top',
    accessibility: false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $('.special__list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    appendArrows: '.special__top',
    accessibility: false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $('.gallery__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '331px',
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          centerMode: true,
          centerPadding: '200px',
        }
      },
      {
        breakpoint: 1023,
        settings: {
          centerMode: true,
          centerPadding: '100px'
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: false,
          centerPadding: '0px'
        }
      }
    ]
  });

}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js